import React from 'react';
import {
  Box,
  CardHeader,
  CardContent,
  Divider,
  Paper,
  Typography,
} from '@mui/material';

interface ACDetail {
  _id: string;
  acType: string;
  quantity: number;
}

interface Props {
  quantity: number;
  place: string;
  comment?: string;
  acDetails: ACDetail[];
}

// Note: "Place Type" is intentionally not rendered here — it's already shown
// once in the shared `CustomerRequestDetails` card above this one. Rendering
// it again here was causing it to appear twice on screen.
const AMCRequestDetailsCard = ({ acDetails }: Props) => {
  return (
    <Box sx={{ color: '#fff' }}>
      <CardHeader
        title="AC Details"
        titleTypographyProps={{
          fontWeight: 600,
          fontSize: 18,
        }}
      />

      <Divider sx={{ borderColor: '#565656' }} />

      <CardContent sx={{ backgroundColor: '#232323', p: 3 }}>
        {acDetails.length === 0 ? (
          <Typography variant="body2" sx={{ color: '#9e9e9e' }}>
            No AC details provided
          </Typography>
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            {acDetails.map((item) => (
              <Paper
                key={item._id}
                elevation={0}
                sx={{
                  backgroundColor: '#2E2E2E',
                  borderRadius: 1,
                  px: 2,
                  py: 1.5,
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    color: '#0BE600',
                    fontWeight: 600,
                    width: '20%',
                    minWidth: 120,
                    textTransform: 'capitalize',
                  }}
                >
                  {item.acType}
                </Typography>

                <Typography variant="body2" sx={{ color: '#FFFFFF' }}>
                  {item.quantity} Unit{item.quantity > 1 ? 's' : ''}
                </Typography>
              </Paper>
            ))}
          </Box>
        )}
      </CardContent>

      <Divider sx={{ borderColor: '#565656' }} />
    </Box>
  );
};

export default AMCRequestDetailsCard;

